















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import sharedStore from '@/modules/shared/shared.store'
import InstantMatchCatalogLogic from '@/modules/instant/mixins/InstantMatchCatalogLogic'
import InstantMatchListItem from '@/modules/instant/components/InstantMatchListItem'
import { HubConnection } from '@microsoft/signalr'
import { CancellationToken } from '@/utils/cancel'
import { getRealtimeConnection } from '@/utils/realtime'

@Component({
  components: {
    InstantMatchListItem
  }
})
export default class InstantMatchCatalogMobile extends mixins(
  InstantMatchCatalogLogic
) {
  @Prop({ required: true })
  gameCode!: string

  @Prop({ required: true })
  region!: string

  sharedModule = getModule(sharedStore, this.$store)
  realtimeConnection!: HubConnection
  realtimeConnectionCancellationToken = new CancellationToken()

  isLoading: boolean = true
  currentRegion: string | null = null

  @Watch('$vuetify.breakpoint.mobile')
  onMobileViewChanged() {
    if (!this.$vuetify.breakpoint.mobile) {
      this.$router.replace({
        name: 'InstantMatchCatalog'
      })
    }
  }

  @Watch('sharedModule.applicationSupportedGames')
  onApplicationSupportedGamesChanged() {
    if (
      !this.sharedModule.applicationSupportedGames ||
      !this.sharedModule.applicationSupportedGames.length
    ) {
      return
    }

    // if the game is not exists, go back
    if (!this.game) {
      this.$router.replace({
        name: 'InstantMatchCatalog'
      })
    }
  }

  @Watch('game')
  async onGameChanged() {
    if (!this.game) return
    this.tournamentList = []
    this.page = 1
    await this.fetchAutomatedTournamentCatalog(
      this.page,
      this.game.code,
      this.currentRegion
    )
  }

  @Watch('currentRegion')
  async onCurrentRegionChanged() {
    if (!this.game) return
    this.tournamentList = []
    this.page = 1
    await this.fetchAutomatedTournamentCatalog(
      this.page,
      this.game.code,
      this.currentRegion
    )
  }

  async created() {
    this.currentRegion = this.region
      ? this.region
      : this.sharedModule.suggestedRegion

    // listen signalR events
    this.realtimeConnection = await getRealtimeConnection(
      this.realtimeConnectionCancellationToken
    )
    this.realtimeConnection.on(
      'automatedTournamentCatalogUpdated',
      this.onAutomatedTournamentCatalogUpdated
    )

    this.onMobileViewChanged()
    this.onApplicationSupportedGamesChanged()
    await this.onGameChanged()

    this.isLoading = false
  }

  beforeDestroy() {
    this.realtimeConnectionCancellationToken.cancel()
    if (this.realtimeConnection) {
      this.realtimeConnection.off(
        'automatedTournamentCatalogUpdated',
        this.onAutomatedTournamentCatalogUpdated
      )
    }
  }

  get game() {
    return this.sharedModule.applicationSupportedGames.find(
      game => game.code.toLowerCase() === this.gameCode.toLowerCase()
    )
  }

  get numOfPlaceholderItem() {
    return Math.max(1, 2 - this.tournamentList.length)
  }

  async onAutomatedTournamentCatalogUpdated() {
    if (!this.game) return

    this.tournamentList = []
    this.page = 1
    await this.fetchAutomatedTournamentCatalog(
      this.page,
      this.game!.code,
      this.currentRegion
    )
    this.$toast.success(this.$t('InstantMatchCatalog.CatalogUpdated'))
  }

  get regionList() {
    return this.sharedModule.applicationRegions
  }

  get regionSelectorList() {
    return [
      {
        value: null,
        text: this.$t('InstantMatchCatalog.AllRegion')
      },
      ...this.sharedModule.applicationRegions.map(region => ({
        value: region.code,
        text: region.name
      }))
    ]
  }

  async onInstantMatchListScroll(e: MouseEvent) {
    if (!this.game) return

    const tournamentListElement = e.target as HTMLDivElement

    if (!tournamentListElement || !this.hasMorePage) {
      return
    }

    const scrollBottom =
      tournamentListElement.scrollHeight - tournamentListElement.scrollTop

    if (scrollBottom < 100) {
      await this.fetchAutomatedTournamentCatalog(
        this.page + 1,
        this.game!.code,
        this.currentRegion
      )
    }
  }
}
